import esMessage from 'devextreme/localization/messages/es.json';
import enMessage from 'devextreme/localization/messages/en.json';
import caMessage from 'devextreme/localization/messages/ca.json';
export const getTranslationByLang = (lang) => {
    switch (lang) {
        case 'es':
            return esMessage;
        case 'en':
            return enMessage;
        case 'ca':
            return caMessage;
        default:
            return esMessage;
    }
};
//# sourceMappingURL=config-devExtreme-locale.js.map